import { getCheckoutForSite } from "@config/site/site-config";
import type { Values } from "../types";

export const FORM_ID = "try-and-buy-form";

const { countryCode } = getCheckoutForSite;

export const INITIAL_VALUES: Values = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    countryCode,
};

export const STORES_LIMIT = 100;

export const SIGN_IN_SOURCE = "Try And Buy";
